import PropTypes from 'prop-types';

export const GiftProductShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  provider: PropTypes.string.isRequired,
  options: PropTypes.string,
  hasOptions: PropTypes.bool,
  isAddressRequired: PropTypes.bool.isRequired,
  isDonation: PropTypes.bool.isRequired,
  isTangoCard: PropTypes.bool.isRequired,
  typeId: PropTypes.number,
});
